<template>
    <div 
        :class="{'container-fluid':true, '--block':color}" 
        :style="`background-color:${color}`">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-8 offset-lg-2" >
                    <template v-for="(item,key) in value">
                        <p 
                            class="content-text content-text--title"
                            v-if="item.type == 'heading'"
                            :key="key">
                            {{item.value.title}}
                        </p>

                        <p 
                            v-else-if="item.type == 'paragraph'" 
                            class="content-text" 
                            v-html="item.value"
                            :key="key"></p>

                        <p 
                            v-else-if="item.type == 'quote'"
                            class="content-text--spotlight"
                            v-html="item.value"
                            :key="key"></p>

                        <picture v-else-if="item.type == 'image'" :key="key">
                            <img class="small-image" :src="utils.image(item.value,736,401)" alt="">
                            <figcaption>{{item.value.title}} — {{item.value.credits}}</figcaption>
                        </picture>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import utils from '@/utils'

export default {
    name: 'SimpleText',
    props:['value', 'color'],
    data() {
        return {
            utils:utils,
        }
    }
}
</script>